import { EnumWrapper } from "../../../../../utils/enums";
import { LANGUAGE_CODES } from "../../../../../utils/enums/enums";
import { Field } from "redux-form";
import { SelectInput } from "../../../../common/form";
import React from "react";
import PropTypes from "prop-types";

const BrokerLanguageField = ({ name, translateFn, extraProps }) => (
  <EnumWrapper enum={LANGUAGE_CODES} format="inputs" prop="options" key={name}>
    <Field
      id={name}
      name={name}
      label={translateFn(name)}
      component={SelectInput}
      addBlankOption={true}
      {...extraProps}
    />
  </EnumWrapper>
);
BrokerLanguageField.propTypes = {
  name: PropTypes.string.isRequired,
  translateFn: PropTypes.func.isRequired,
  extraProps: PropTypes.object,
};

export default BrokerLanguageField;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/brokers/formSections/BrokerLanguageField.js